import NewForm from "../Components/NewForm";

function New() {
    return (
       <NewForm />
    );
}

export default New;